import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

const BirthdayMonth = (props) => {
	const { t, i18n } = useTranslation();

	const {form_component} = props;

	const fv = useSelector(state => state.fv);
	const userData = useSelector(state => state.userData);

	useEffect(() => { // to be updated after render
		if (fv && form_component.required) {
			fv.addField('birthday[day]', {
				validators: {
					notEmpty: {
						message: t('此欄為必須填寫')
					}
				}
			});
		}
	}, [fv]);

	var days = [];
    if (form_component.date_select_na) {
        days[0] = t('不適用');
    }
    for (let i = 1; i <= 31; ++i) {
        days[i] = i;
    }

	return (
		<div className="d-flex align-items-center">
			<div className="me-3">
				<div className="mb-3 form-group select">
					<select
						className="form-select-sm w-date form-select"
						defaultValue={userData ? userData.birthday.day : ''}
						name="birthday[day]"
					>
						<option value="">-</option>
						{(() => {
							const components = [];
							
							days.map((day, index) => {
								components.push(
									<option key={`day-${index}`} value={day}>{day}</option>
								);
							});

							return components;
						})()}
					</select>
				</div>
			</div>
			<div className="pb-3">{t('日')}</div>
		</div>
	);
}

export default BirthdayMonth;